import type { Page } from './route';

/** Links between the admin pages. Pressing the link of the page already shown does nothing, so it cannot reset that page. */
export function Nav({ current }: { current: Page }) {
  const link = (page: Page, href: string, label: string) => (
    <a
      href={href}
      aria-current={current === page ? 'page' : undefined}
      onClick={(e) => { if (current === page) e.preventDefault(); }}
    >
      {label}
    </a>
  );
  return (
    <nav aria-label="Pages" className="nav">
      {link('map', '#/', 'Map')}
      {link('mannequin', '#/mannequin', 'Mannequin')}
    </nav>
  );
}
